<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('quotation.academic') }}</legend>
        <div class="row form-group">
            <label class="col-form-label col-md-4 required">{{
              $t('quotation.quotationDate')
            }}</label>
            <div class="col-md-8">
              <a-date-picker
                :style="{ width: '100%' }"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                v-model="model.quot_date"
              />
              <div class="validate" v-if="errors.has('quot_date')">
                {{ errors.first('quot_date') }}
              </div>
            </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('quotation.mainProgram')
          }}</label>
          <div class="col-md-8">
            <a-select
                  v-model="model.acp_id"
                  class="ts-w-full"
                  :options="mainPrograms"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
            ></a-select>
            <div class="validate" v-if="errors.has('acp_id')">
              {{ errors.first('acp_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('quotation.academicTerm')
          }}</label>
          <div class="col-md-8">
            <a-select
                  v-model="model.ac_term_id"
                  class="ts-w-full"
                  :options="acTerms"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
            ></a-select>
            <div class="validate" v-if="errors.has('ac_term_id')">
              {{ errors.first('ac_term_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('quotation.grade')
          }}</label>
          <div class="col-md-8">
            <a-select
                  v-model="model.grade_id"
                  class="ts-w-full"
                  :options="grades"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
            ></a-select>
            <div class="validate" v-if="errors.has('grade_id')">
              {{ errors.first('grade_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('quotation.studyTime')
          }}</label>
          <div class="col-md-8">
            <input
              type="text"
              class="form-control-plaintext ts-text-sm"
              readonly
              :value="model.study_time"
            />
            <div class="validate" v-if="errors.has('study_time')">
              {{ errors.first('study_time') }}
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'quotationAcademic',
  props: ['value', 'studentInfo', 'validate'],
  data() {
    return {
      model: {},
      grades: [],
      mainPrograms: [],
      subPrograms: [],
      acTerms: [],
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
		this.getViewModel()
  },
  methods: {
		...mapActions('quotation', ['formViewModel']),
		getViewModel() {
      this.formViewModel({
				fnName: 'mainProgram,term,grade',
			})
        .then(response => {
          this.mainPrograms = response.mainProgram.map(el => ({
						value: el.acp_id,
						label: el.acp_name_foreign
					}))
					this.grades = response.grade.map(el => ({
						value: el.grade_id,
						label: el.grade_name_foreign
					}))
          this.acTerms = response.term.map(el => ({
						value: el.ac_term_id,
						label: el.term_name
					}))
        })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
